import cx from 'classnames'
import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import {PanelBasic} from '@adv-mt/mt-panel-basic'
import SectionBasic from '@adv-mt/mt-section-basic'

import {PanelFinancingClaims} from './components/claims/PanelFinancingClaims.js'
import {PANEL_FINANCING_VERSION} from './components/config.js'
import {PanelFinancingContentLayout} from './components/content/PanelFinancingContentLayout.js'
import {PanelFinancingHeader} from './components/header/PanelFinancingHeader.js'
import {useUtils} from './hooks/useUtils.js'

export const PanelFinancing = ({
  ad,
  financingData = {},
  id,
  onCalculatorChange = () => {},
  onContactSellerCtaClick,
  seller = {},
  vehicleInfo = {}
}) => {
  const {getPanelFinancingVersion} = useUtils()

  const {lender} = financingData || {}
  const hasFinancingData = Boolean(lender)

  const hideClaims = seller.isDealer && !financingData?.calculatorB2cData

  const panelFinancingVersion = getPanelFinancingVersion({
    isProfessional: seller.isDealer,
    loanCalculations: financingData
  })

  const classNamePanelFinancing = cx({
    'mt-PanelFinancing': panelFinancingVersion !== PANEL_FINANCING_VERSION.SIMPLIFIED,
    'mt-PanelFinancing-simplified': panelFinancingVersion === PANEL_FINANCING_VERSION.SIMPLIFIED
  })

  const classNamePanelFinancingContainer = cx({
    'mt-PanelFinancing-container': panelFinancingVersion !== PANEL_FINANCING_VERSION.SIMPLIFIED,
    'mt-PanelFinancing-containerSimplified': panelFinancingVersion === PANEL_FINANCING_VERSION.SIMPLIFIED
  })

  return (
    <>
      {hasFinancingData && (
        <SectionBasic id={id}>
          <PanelBasic>
            <div className={classNamePanelFinancing}>
              <PanelFinancingHeader financingData={financingData} isProfessional={seller.isDealer} />
              <div className={classNamePanelFinancingContainer}>
                {!hideClaims && (
                  <PanelFinancingClaims ad={ad} financingData={financingData} isProfessional={seller.isDealer} />
                )}
                <PanelFinancingContentLayout
                  ad={ad}
                  isProfessional={seller.isDealer}
                  financingData={financingData}
                  onCalculatorChange={onCalculatorChange}
                  onContactSellerCtaClick={onContactSellerCtaClick}
                  vehicleInfo={vehicleInfo}
                />
              </div>
            </div>
          </PanelBasic>
        </SectionBasic>
      )}
    </>
  )
}

PanelFinancing.propTypes = {
  ad: PropTypes.object,
  seller: PropTypes.string,
  financingData: PropTypes.object,
  id: PropTypes.string,
  onCalculatorChange: PropTypes.func,
  onContactSellerCtaClick: PropTypes.func,
  vehicleInfo: PropTypes.object
}

export default PanelFinancing
